import { CreditCardConvertDuotone } from "@bonusx-global/bx-icons";
import styled from "@emotion/styled";

export const CreditCardConvertDuotoneBig = styled(CreditCardConvertDuotone)`
  height: 5rem;
  width: 5rem;
`;
